import React from "react";
import './nav.css';

const Nav = () => {
  return( 
    <div className="nav-bar">
      <h1>Contact Manager</h1>
    </div>
  )
};

export default Nav;
